import React from 'react'
import './community-features.scss'
import { Fade } from 'react-reveal'
import Image from '../../../assets/img/Project-Images/img2.jpeg'
import useFetch from '../../../Hooks/useFetch'

export default function CommunityFeatures({ projectNumber }) {
  const { data } = useFetch()
  const fea = projectNumber?.fields.cfParagraph.split(',')
  // fea?.map((f) => console.log(f))
  return (
    <div id='com-fea'>
      <img
        src={projectNumber?.fields.cfImg.fields.file.url}
        alt='azca community'
      />
      <Fade left>
        <div className='dark-card'>
          <div>
            <h2>{projectNumber?.fields.cfTitle}</h2>
            <p>
              <ul>
                {fea?.map((feature) => (
                  <li>{feature}</li>
                ))}
              </ul>
            </p>
          </div>
        </div>
      </Fade>
    </div>
  )
}
